import React, { createContext, useState, useEffect, useContext } from "react";
import axios from "./axiosConfig";
import Cookies from "js-cookie";
import { notification } from "antd";

const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
	const [isAuthenticated, setIsAuthenticated] = useState(null);
	const [user, setUser] = useState(null);

	// Sprawdzenie sesji użytkownika
	const checkSession = async () => {
		const token = Cookies.get("mgltoken");

		if (!token) {
			setIsAuthenticated(false);
			setUser(null);
			return;
		}

		try {
			const response = await axios.post(
				`${process.env.REACT_APP_API_URL}/auth/session/check`,
			);
			setIsAuthenticated(response.data.authenticated);
		} catch (error) {
			console.error("Session check failed:", error);
			setIsAuthenticated(false);
		}
	};

	// Pobranie danych użytkownika
	const fetchUser = async () => {
		try {
			const response = await axios.post(
				`${process.env.REACT_APP_API_URL}/auth/get/user`,
			);
			const perms = await axios.post(
				process.env.REACT_APP_API_URL + "/perms/get/by/user",
				{},
				{
					headers: {
						Authorization: Cookies.get("mgltoken"),
						App: process.env.REACT_APP_APP_KEY,
					},
				},
			);
			setUser({ ...response.data, perms: perms.data });
		} catch (error) {
			console.error("Error fetching user:", error);
			setUser(null);
		}
	};

	useEffect(() => {
		checkSession();
	}, []);

	useEffect(() => {
		if (isAuthenticated) {
			fetchUser();
			return;
		}

		if (isAuthenticated === false) {
			setUser(null);
		}
	}, [isAuthenticated]);

	return (
		<AuthContext.Provider value={{ isAuthenticated, user }}>
			{children}
		</AuthContext.Provider>
	);
};

export const useAuth = () => useContext(AuthContext);
